import React from "react";
import "./BillOfMaterials.css";
import boms from "../../pages/v2/jsons/bom.json";
import materials from "../../pages/v2/jsons/materials.json";
import countries from "../../pages/v2/jsons/countries.json";
import { useTranslation } from 'react-i18next';

const BillOfMaterials = ({ data = [] }) => {
  const { t, i18n } = useTranslation();

const getBOM = (code) => {
  const bom = boms.find((bom) => bom.code === code);
  if (!bom) return t("unknown");
  return bom.description[i18n.language] || bom.description.en;
};

const getMaterialDescription = (materialCode) => {
  if (!materialCode) return t("unknown-material");

  const material = materials.find((mat) => mat.code === materialCode);
  if (!material) return t("unknown-material");

  return material.description[i18n.language] || material.description.en;
};

const getCountryDescription = (countryCode) => {
  if (!countryCode) return t("unknown-country");

  const country = countries.find((c) => c.code === countryCode);
  if (!country) return t("unknown-country");

  return country.description?.[i18n.language] || country.description?.en || t("unknown-country");
};

  const renderOrigin = (item) => {
    const supplier = item?.supplier;
    if (!supplier) return null;

    const companyName = supplier.name || t("unknown-supplier");
    const countryName =
      getCountryDescription(supplier.country) || t("unknown-country");

    return (
      <div className="origin-wrap">
        <span className="origin-company">{companyName}</span>
        <span className="origin-country">{countryName}</span>
      </div>
    );
  };

  // ✅ Se não houver dados, mostra mensagem
  if (!data || data.length === 0) {
    return (
      <div className="tabela-container" style={{ alignItems: "center" }}>
        <div className="longtext-text centered-text">
          <p>{t('bill-of-materials-not-available')}.</p>
        </div>
      </div>
    );
  }

  const hasOriginColumn = data.some((item) => item?.supplier);

  const getTitleImageForType = (type, isLast) => {
    const baseClass = isLast ? "type-bom-last" : "type-bom";
    const iconMap = {
      ACCESSORY_BUTTON: "icon_button_accessorie.svg",
      ACCESSORY_PEARL_SEQUIN: "icon_bling_accessorie.svg",
      ACCESSORY_ZIPPER: "icon_zipper_accessorie.svg",
      ACCESSORY_RIVET_EYELETS: "icon_rivet_accessorie.svg",
      ACCESSORY_TAPE: "icon_bow_accessorie.svg",
      ACCESSORY_CORD: "icon_cord_accessorie.svg",
      ACCESSORY_SPRING: "icon_spring_accessorie.svg",
      ACCESSORY_ELASTIC: "icon_elastic_accessorie.svg",
      ACCESSORY_LACE: "icon_lace_accessorie.svg",
      ACCESSORY_COLLAR: "icon_collar_accessorie.svg",
      ACCESSORY_MEDAL: "icon_medal_accessorie.svg",
      ACCESSORY_VENT_NET: "icon_net_accessorie.svg",
      ACCESSORY_ADHESIVE_TAPE: "icon_adhesive_accessorie.svg",
      ACCESSORY_STOPPER: "icon_stopper_accessorie.svg",
      ACCESSORY_BRACKET: "bracket_icon.svg",
      ACCESSORY_SHOULDERPADS: "shoulder_pads_icon.svg",
      ACCESSORY_LINNING: "linning_icon.svg",
      ACCESSORY_BUCKLES: "buckles_icon.svg",
      ACCESSORY_LABEL: "label_icon.svg",
    };

    const iconSrc = `./images/${iconMap[type] || "add_accessorie.svg"}`;

    return (
  <td className={baseClass}>
    <div className="type-wrap">
      <img className="acessory-bom-icon" src={iconSrc} alt="" />
      <span className="span-bom-text">{getBOM(type)}</span>
    </div>
  </td>
);
  };

  return (
    <div className="tabela-container">
      <table className={`tabela ${hasOriginColumn ? "has-origin" : "no-origin"}`}>

        <thead>
          <tr className="tabela-heads">
            <th className="head-type">{t('type')}</th>
            <th className="head-quantity">{t('quantity')}</th>
            <th className="head-material">{t('material')}</th>
            {hasOriginColumn && <th className="head-origin">{t('origin')}</th>}
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => {
            const isLast = index === data.length - 1;

            const quantity = item.quantity ?? "N/A";
            const materialCode = Array.isArray(item.material)
              ? item.material[0]
              : item.material;
            const unit = (() => {
              if (item.units) return ` ${item.units}`;
              if (item.code === "ACCESSORY_LINNING" || item.code === "ACCESSORY_SHOULDERPADS" || item.code === "ACCESSORY_TAPE") return " kg";
              if (item.code === "ACCESSORY_LACE" || item.code === "ACCESSORY_ELASTIC") return " g";
              return " un";
            })();

            const materialClass = hasOriginColumn
              ? (isLast ? "material-last" : "material")
              : (isLast ? "material-last" : "material-last");

            return (
              <tr key={`${item.code}-${index}`}>
                {getTitleImageForType(item.code, isLast)}

                <td className={isLast ? "quantity-last" : "quantity"}>
                  {item.quantity != null ? (
                    <>
                      {quantity}
                      {unit}
                    </>
                  ) : (
                    <span style={{ textTransform: "uppercase" }}>N/A</span>
                  )}
                </td>

                <td className={materialClass}>
                  {getMaterialDescription(materialCode)}
                </td>

                {hasOriginColumn && (
                  <td className={isLast ? "origin-last" : "origin"}>
                    {renderOrigin(item)}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BillOfMaterials;
